/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_api_keys_create_drawer_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Esta es la única vez que te mostraremos la llave completa. Por favor cópiala y guárdala en un lugar seguro.`
};

const en_developer_api_keys_create_drawer_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `This is the only time we will show you the full API key. Please copy it and store it somewhere safe.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_api_keys_create_drawer_success_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_api_keys_create_drawer_success_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_api_keys_create_drawer_success_message", locale)
	if (locale === "es") return es_developer_api_keys_create_drawer_success_message(inputs)
	return en_developer_api_keys_create_drawer_success_message(inputs)
};
export { developer_api_keys_create_drawer_success_message as "developer.api_keys.create_drawer.success_message" }